module.exports = __webpack_public_path__ + "static/media/tip_text_dog_flea_fr.51e2b82a.svg";